export default __webpack_public_path__ + "static/media/Our Vision.1e00bb15.jpg";